import { render, staticRenderFns } from "./detailsBox.vue?vue&type=template&id=edaf9f78&"
import script from "./detailsBox.vue?vue&type=script&lang=js&"
export * from "./detailsBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports